/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:44:28
 */
export default {
  lang: "英语",
  landing: {
    name1: "Abir Carlcare",
    name2: "Fazer um agendamento",
    name3: "Com o Carlcare, é possível verificar seu pedido a qualquer momento.",
    name4: "",
    name5: "Deslize para a direita",
    name6: "Verificação concluída",
  },
  order: {
    name1: "Escolha o modelo do dispositivo",
    name2: "Descrição da falha:",
    name3: "Toque para selecionar a loja de serviço",
    name4: "Loja de serviço:",
    name5: "Hora do agendamento:",
    name6: "Descreva detalhadamente o problema do dispositivo.",
    name7: "Toque para selecionar a hora de chegada",
    name8: "Insira os detalhes de contato corretos para podermos entrar em contato com você",
    name9: "Hora do agendamento disponível conforme indicado a seguir",
    name10: "Digite seu número de telefone",
    name11: "Preço",
    name12: "Informações pessoais:",
    name13: "Insira seu nome",
    name14: "Submeter",
    name15: "Cancelar",
    name16: "Está bem",
  },
  shops: {
    name1: "Com base na marca de sua escolha, as seguintes lojas poderão atender você.",
    name2: "Em breve em mais lojas de varejo! Fique conosco!",
  },
  price: {
    name1: "Marca",
    name2: "Modelo",
    name3: "ITEM",
    name4: "Preço",
    name5: "Lembrete amigável:",
    name6: "Estes preços são apenas para referência e o preço real está sujeito à condição do seu dispositivo.",
    name7: "Se não houver nenhum símbolo especial, a unidade de preço será a unidade de moeda local.",
    name8: "Lamentamos! Nenhuma informação de preço disponível na região atual.",
    name11:"Custo de mão de obra",
    name12:"Preço total",
    name13: "5. Se o custo da mão-de-obra é \"/\", isso significa que o custo da mão-de-obra precisa ser consultado com a loja.",
    item_main_board: "Placa mãe",
    item_screen_frame: "Tela (Quadro)",
    item_screen_screen_frame: "Tela secundária (Quadro)",
    item_touch_screen: "Tela sensível ao toque",
    item_camera: "\"Câmara\"",
    item_fixed_focus_camera: "Câmera de foco fixo",
    item_auto_focus_camera: "Câmera de foco automático",
    item_screen: "Tela",
    item_secondary_screen: "Tela secundária",
    item_fingerprint_module: "Módulo de impressão digital",
    item_speaker: "Alto-falante",
    item_receiver: "Receptor",
    item_small_board: "Placa pequena",
    item_battery_cover: "Tampa da bateria",
    item_battery: "Bateria",
    item_charger: "Carregador",
    item_usb_cable: "Cabo USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Sem dados",
    name2: "Provedor de serviços:",
    name3: "Marca de serviço:",
    name4: "Telefone:",
    name5: "Quantidade do pedido:",
    name6: "Classificação do serviço",
    name7: "Ambiente do serviço:",
    name8: "Altitude do serviço:",
    name9: "Eficiência do serviço:",
    name10: "Qualidade do serviço:",
    name11: "Avaliação de clientes",
    name12:"para",
    name13:"Desativado",
    name14:'"Endereço":',
    "name6_5": "Tempo de Serviço"
  },
  reserSuccess: {
    // name1:
    //   "Abir Carlcare",
    name1: "Capture a tela nas informações de reserva e salve como um recibo para acessar o serviço prioritário.",
    name2: "Enviado com sucesso",
    name3: "1. Remova dados",
    name4: "Faça backup de dados privados importantes no telefone com antecedência",
    name5: "2. Desative a senha de ativação",
    name6: "Antes de ir até a loja de serviço:",
    name7: "Loja de serviço:",
    name8: "Hora do agendamento:",
    name9: "Descrição da falha:",
    name10: "Modelo do dispositivo:",
    name11: "Número do pedido:",
    name12: "Informações do pedido",
  },
  title: {
    
    name1: "Suporta os seguintes países:",
    name2: "Escolher modelo",
    name3: "Reserva",
    name4: "Detalhes da loja de serviço",
    name5: "Selecionar loja de serviço",
  },
  error: {
    
    name1: "Sem dados. Verifique as informações de reparo",
    name2: "Precisa de mais ajuda? Entre em contato conosco.",
    name3: "Lamentamos, não há central do Carlcare na região atual.",
    name4: "Escolha uma central de serviços primeiro",
    name5: "Falhou",
    name6: "Primeiro, selecione o modelo",
    name7: "Detalhes",
    name8: "Descrevas em detalhes as necessidades",
    name9: "",
    
  },
  add1:{ //延用pt-rPT
    "name0": "pt-rPT",
    "name1": "Sua encomenda foi confirmada. Estamos ansiosos para sua chegada.",
    "name2": "Selecioná-lo da cidade",
    "name3": "Por favor introduza um número de telemóvel com %1$s dígitos.",
    "name4": "Horários do Dia Útil",
    "name5": "Segunda-feira",
    "name6": "Terça-feira",
    "name7": "Quarta-feira",
    "name8": "Quinta-feira",
    "name9": "Sexta-feira",
    "name10": "Sábado",
    "name11": "Domingo",
    "name12": "Introduzir país e pesquisar"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Outros",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Toque para redirecionar",
    name3:"Abra o aplicativo Carlcare para avaliar o pedido",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Selecionar serviço",
    name7:"Limpeza grátis",
    name8:"Atualização de software",
  },
  cancelorder:{
    "cancelReason0": "Informações incorretas",
    "cancelReason1": "Não é possível chegar a tempo",
    "cancelReason2": "Pedido duplicado/não é meu pedido",
    "cancelReason3": "A falha não se repete",
    "cancelReason4": "Apenas para teste/consulta/evento/…",
    "cancelReason5": "Preço alto",
    "cancelReason6": "Falta de material",
    "cancelReason7": "Sem serviços diferenciados",
    "cancelReason8": "A loja é muito distante",
    "cancelReason9": "A loja está fechada",
    "cancelReason10": "Atitude ruim de serviço",
    "cancelReason11": "Substituição/reparo de outras marcas",
    "cancelReason12": "Não consigo encontrar a loja",
    "cancelReason13": "Outros",
    "cancelOrder": "Cancelar pedido",
    "reason_dialog_title": "Conte-nos o motivo do cancelamento",
    "Cancel": "Cancelar",
    "OK": "Está bem",
    "name1": "Digite o código de verificação",
    "name2": "Código de verificação inválido",
    "repair_reservation_detail_canceled": "Este pedido foi cancelado!",
    "purchase_cancel_dialog_content": "Confirma o cancelamento do pedido?",
    "yes": "\"Sim\"",
    "no": "Não"
},
onSiteService:{
  "name1": "Reparo na Loja",
  "name2": "Serviço no Local",
  "name3": "Você precisa ativar a Localização para usar o serviço no local. Ative e tente novamente.",
  "name4": "Selecione a sua localização:",
  "name5": "Pedidos no local",
  "name6": "Localização atual:",
  "name7": "\"Endereço:\"",
  "name8": "Nome",
  "name9": "Telefone:"
},
smartService:{
  "cancelReason0": "Não consigo encontrar o gabinete",
  "cancelReason1": "O gabinete está muito longe",
  "cancelReason2": "O gabinete não está disponível",
  "cancelReason3": "Não precisa de reparo",
  "cancelReason4": "Escolha outro método de reparo",
  "name0": "Enter verification code",
  "name1": "Código de verificação",
  "name2": "Serviço de Armário Inteligente",
  "name3": "Armário de Serviços:",
  "name4": "Navegue até o armário",
  "name5": "Selecione o armário de serviço",
  "name6": "Endereço do Armário:",
  "name7": "Telefone de Serviço:",
  "name8": "Toque para buscar armários de serviço",
  "name9": "Selecione o armário de serviço",
  "name10": "Depositado. Você armazenou o dispositivo no gabinete",
  "name11": "Retirado. O entregador pegou o dispositivo",
  "name12": "Depositado. O entregador armazenou o dispositivo no gabinete",
  "name13": "Retirado. Você pegou o dispositivo",
  "name14": "Pedidos de gabinete inteligente",
  "name15": "Depositado",
  "name16": "Retirado",
  "name17": "Com base na marca que você escolher, os seguintes armários podem atendê-lo!",
  "name18": "Em breve em mais armários. Fique atento!",
  "name19": "Submetido",
  "name20": "Reparando",
  "name21": "Reparado",
  "name22": "Rejeitado",
  "name23": "Revisado",
  "name24": "Vencido",
  "name25": "Cancelada",
  "name26": "Status do pedido:",
  "name27": "Hora da criação:",
  "name28": "Número de telefone",
  "name29": "Finalizado, a ser revisado",
  "name30": "Want to come to service center immediately",
  "name31": "Avalie o pedido",
  "name32": "Este pedido foi cancelado!",
  "name33": "the order can‘t be canceled when it had been picked",
  "name34": "Display only the last 30 days of orders",
  "name35": "Pls select the reason for cancellation",
  "name36": "pls enter verification code to cancel order",
  "name66_66_66":"",
}
};
